module.exports = __webpack_public_path__ + "media/mourning-dove-2.3ad4a115.mp3";